import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 当前appKey */
    public appKey: string;
    /** 激活弹框 */
    public activTipsM: boolean = false;
    public isReadCheckd: boolean = false;
    public appCategories: Array<any> = [];
    public appAgreementContent: string;
    /** 应用基本信息 */
    public appInfo: {
        appCompany: string;
        appDescription: string;
        appIcon: string;
        appId: number;
        appIndexUri: string;
        appIntroduction: string;
        appInstanceAK: string;
        appInstanceSK: string;
        appType: number;
        appKey: string;
        appName: string;
        categoryName: string;
        isActivated: number;
        appSecret: string;
    } = {
        appCompany: '',
        appDescription: '',
        appIcon: '',
        appId: 0,
        appIndexUri: '',
        appIntroduction: '',
        appKey: '',
        appName: '',
        categoryName: '',
        isActivated: 0,
        appInstanceAK: '',
        appInstanceSK: '',
        appType: undefined,
        appSecret: undefined,
    };
    public tabchange: string;
    /** 实例权限列表: 用户 */
    permissionUserObjects: {
        objectId: string;
        objectName?: string
        objectType: number;
        objectUniqueKey?: string;
    }[] = [];
    /** 实例权限列表: 部门 */
    permissionDepObjects: {
        objectId: string;
        objectName: string
        objectType?: number;
        objectUniqueKey?: string;
    }[] = [];
    /** 被勾选的部门值 */
    permissionDepObjectsValues: any[];
    /** 查询公司人员 */
    companyUserParam: {
        nickName: string;
        email: string;
        pageNum: number;
        pageSize: number;
    } = {
        nickName: '',
        email: '',
        pageNum: 1,
        pageSize: 10,
    };
    /** 公司人员 */
    companyUserList: {
        acceptStatus: string;
        companyId: string;
        credential: any;
        departmentId: string;
        departmentName: string;
        description: string;
        email: string;
        gUserId: string;
        isActivated: boolean;
        isDeleted: boolean;
        lastLoginIp: string;
        lastLoginTime: number;
        nickName: string;
        phone: string;
        userId: string;
        userType: string;
    }[] = [];
    public departmentQuery: {
        createTime: number,
        departmentId: string,
        description: string,
        isDeleted: boolean,
        name: string,
        number: string,
        parentDepartmentId: string,
        updateTime: number
    }[]; 
    public departtreeDate: any[];
    /** 模糊搜索 */
    onSearch: string = undefined;
    /** 公司人员分页 信息 */
    pageMeta: {
        pageNum: number;
        pageSize: number;
        pages: number;
        total: number;
    } = {
        pageNum: 0,
        pageSize: 0,
        pages: 0,
        total: 0,
    };
    disabledModal: boolean = false;
}



// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppDetail/Modules.State.ts